export default "__VITE_ASSET__DGVxV21V__"